/* Salt + Ember — Discovery Set builder.
   Pick exactly N scents; the set is ONE product at a fixed price, and the
   chosen scents ride along as line item properties. Deliberately not run
   through the tiered bundle discount — this set has its own fixed price. */
(function () {
  const root = document.querySelector('[data-discovery-set]');
  if (!root) return;

  const PICK = parseInt(root.dataset.pickCount, 10) || 4;
  const VARIANT_ID = root.dataset.variantId;
  const SOLD_OUT = root.dataset.soldOut === 'true';

  const cards = [...root.querySelectorAll('[data-ds-card]')];
  const slotsEl = root.querySelector('[data-ds-slots]');
  const statusEl = root.querySelector('[data-ds-status]');
  const counterEl = root.querySelector('[data-ds-counter]');
  const addBtn = root.querySelector('[data-ds-add]');
  const giftEl = root.querySelector('[data-ds-gift]');
  const bar = root.querySelector('[data-ds-bar]');

  // Captured from the markup so the restored label always matches whatever the
  // merchant set in the theme editor, rather than a hardcoded guess.
  const ADD_LABEL = addBtn ? addBtn.textContent.trim() : 'Add Set to Cart';

  /** @type {string[]} chosen scent names, in pick order; duplicates allowed */
  const chosen = [];

  function remaining() {
    return PICK - chosen.length;
  }

  function render() {
    const left = remaining();

    counterEl.textContent =
      left > 0 ? `Choose ${left} more scent${left === 1 ? '' : 's'}` : `Your set is complete`;

    statusEl.textContent =
      left > 0 ? `${chosen.length} of ${PICK} chosen` : `${PICK} of ${PICK} — ready`;

    addBtn.disabled = SOLD_OUT || left !== 0;
    bar.classList.toggle('is-ready', left === 0);

    // slots: filled chips then empty placeholders
    slotsEl.innerHTML = '';
    for (let i = 0; i < PICK; i++) {
      const slot = document.createElement('span');
      if (chosen[i]) {
        slot.className = 'ds__slot is-filled';
        slot.innerHTML = `${chosen[i]} <button type="button" class="ds__slot-remove" data-ds-remove="${i}" aria-label="Remove ${chosen[i]}">&times;</button>`;
      } else {
        slot.className = 'ds__slot';
        slot.textContent = `Scent ${i + 1}`;
      }
      slotsEl.appendChild(slot);
    }

    // reflect selection count on each card
    cards.forEach((card) => {
      const name = card.dataset.scent;
      const count = chosen.filter((c) => c === name).length;
      const btn = card.querySelector('[data-ds-toggle]');
      card.classList.toggle('is-selected', count > 0);
      btn.setAttribute('aria-pressed', count > 0 ? 'true' : 'false');
      const check = card.querySelector('.ds__check');
      if (check) check.textContent = count > 1 ? `×${count}` : '✓';
    });
  }

  cards.forEach((card) => {
    card.querySelector('[data-ds-toggle]').addEventListener('click', () => {
      const name = card.dataset.scent;
      if (remaining() > 0) {
        chosen.push(name);
        statusEl.textContent = '';
      } else {
        // Set is full: tapping a chosen scent removes one of it.
        const idx = chosen.lastIndexOf(name);
        if (idx > -1) {
          chosen.splice(idx, 1);
          statusEl.textContent = '';
        } else {
          // Tapping an unchosen scent on a full set previously did nothing at
          // all, silently. Say why, rather than letting it read as broken.
          statusEl.textContent = `Your set is full. Remove one to swap ${name} in.`;
          return;
        }
      }
      render();
    });
  });

  slotsEl.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ds-remove]');
    if (!btn) return;
    chosen.splice(parseInt(btn.dataset.dsRemove, 10), 1);
    render();
  });

  addBtn.addEventListener('click', async () => {
    if (remaining() !== 0) return;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding…';

    const properties = {};
    chosen.forEach((name, i) => {
      properties[`Scent ${i + 1}`] = name;
    });
    if (giftEl && giftEl.checked) properties['Gift'] = 'Yes';

    // Open the cart drawer rather than redirecting to /cart. The drawer carries
    // the free shipping bar and the accessories upsell; /cart carries neither,
    // so redirecting sent the highest-value flow to the barest surface.
    const cartDrawer = document.querySelector('cart-drawer');
    const body = { items: [{ id: Number(VARIANT_ID), quantity: 1, properties }] };
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      body.sections = cartDrawer.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify(body),
      });
      const parsed = await res.json();
      // /cart/add.js is atomic: one unavailable variant fails the whole add and
      // returns a 4xx with a description. Surface it instead of failing quietly.
      if (!res.ok || parsed.status) {
        throw new Error(parsed.description || parsed.message || 'cart/add failed: ' + res.status);
      }

      addBtn.textContent = 'Added';
      statusEl.textContent = '';
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(parsed);
        addBtn.disabled = false;
        addBtn.textContent = ADD_LABEL;
      } else {
        window.location.href = '/cart'; // no drawer on this theme setting
      }
    } catch (err) {
      addBtn.disabled = false;
      addBtn.textContent = ADD_LABEL;
      statusEl.textContent = "Sorry, we couldn't add that set. Please try again, or email us and we'll sort it.";
      console.error('[discovery-set]', err);
    }
  });

  render();
})();
